import { Component, OnInit, Output, EventEmitter, Inject, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';

import { environment } from '../../../environments/environment';

import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Observable } from 'rxjs';
import { Notificacion } from '../../core/models/Notificacion';
import { UserProfileService } from '../../core/services/user.service';
import { CambioContrasena } from '../../core/models/CambioContrasena';
import { User } from '../../core/models/auth.models';


@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})

/**
 * Topbar component
 */
@Injectable({
  providedIn: 'root',
})
export class TopbarComponent implements OnInit {
  tooltipvalidationform: UntypedFormGroup;
  CurrentDate:Date
  element;
  configData;
  currentUser:User;
  nueva:string;
  actual:string;
  confirma:string;
  document: any = inject(DOCUMENT);
  formsubmit: boolean;
  total:number;
  notificaciones :  Observable<Notificacion[]>
  constructor( public api:UserProfileService,  public formBuilder: UntypedFormBuilder,private modalService: NgbModal, private router: Router, private authService: AuthenticationService,
              private authFackservice: AuthfakeauthenticationService) {
                this.currentUser = this.authFackservice.currentUserValue;
                this.notificaciones =this.api.getNotificaciones(this.currentUser.IdCompania, this.currentUser.IdUsuario);
           this.notificaciones.subscribe(data=>{
             this.total= data.length;
           })
               }

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit() {
    this.openMobileMenu = false;
    this.element = document.documentElement;
    this.tooltipvalidationform = this.formBuilder.group({
      actual: ['', [Validators.required,Validators.pattern('[a-zA-Z0-9]+')]],
      nueva: ['', [Validators.required,Validators.minLength(6), Validators.pattern('[a-zA-Z0-9]+')]],
      confirma: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9]+')]]
    });
    this.formsubmit = false;

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3
    };
  }
  formSubmit() {
    if (this.tooltipvalidationform.valid) {
      if (this.nueva!=this.confirma){
        Swal.fire('Alerta!', 'Su contraseñas no coinciden!', 'error');
      }else{
        this.CambiarContrasena();
      }

      console.log('form submitted');
    } else {
      // validate all form fields
    }
    this.formsubmit = true;
  //  this.CambiarContrasena();

  }
  get formData() {

    return this.tooltipvalidationform.controls;
  }
  CambiarContrasena():void {
    const bar: CambioContrasena = {usuario: this.currentUser.IdUsuario, actual: this.actual ,clave:this.nueva };
    if (this.nueva==this.confirma){

   this.authFackservice.cambiarcontrasena(bar).subscribe(data=>{
    if (data==true){
      Swal.fire('Exitoso!', 'Su contraseña se cambio con éxito!', 'success');
      this.modalService.dismissAll();
    }
    else{
      Swal.fire('Alerta!', 'La contraseña actual es incorrecta !', 'error');
     // this.modalService.dismissAll();
    }
   });

    }
    else{
      Swal.fire('Alerta!', 'La contraseña no coinciden!', 'error');
    }



  }
  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    if (environment.defaultauth === 'firebase') {
      this.authService.logout();
    } else {
      this.authFackservice.logout();
    }
    this.router.navigate(['/account/login']);
  }
  openModal(content: any) {
    this.modalService.open(content);
  }
  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
}
